import {AppBox, AppContainer, AppPaginator} from "../../../commons/components";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/app";
import {cleanUpTeamList, fetchManageTeamList} from "../../../redux/slices/football/admin/team/manage-team-list-slice";
import TeamList from "./components/TeamList";
import {Outlet, useParams} from "react-router";
import {setPageTitle} from "../../../redux/slices/page-title-slice";
import {cleanUpManageTeamPlayers} from "../../../redux/slices/football/admin/team/squad/manage-team-players-slice";
import {cleanUpManageTeamCompetitions} from "../../../redux/slices/football/admin/team/manage-team-competitions-slice";
import {
    cleanUpManageStanding
} from "../../../redux/slices/football/admin/competition/manage-competition-season-standing-slice";
import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";

export default function TeamManage() {
    const dispatch = useAppDispatch();
    const {teamList} = useAppSelector((state) => state.footballManageTeamList);

    const {page, pageChange, pageLimitChange, perPage} = usePagination();
    const {sortBy, sortOrder, status, searchText} = useFilter();

    useEffect(() => {
        dispatch(setPageTitle("Teams"));
        return () => {
            dispatch(cleanUpTeamList());
            dispatch(cleanUpManageTeamPlayers());
            dispatch(cleanUpManageTeamCompetitions());
            dispatch(cleanUpManageStanding());
        };
    }, []);

    const {teamId} = useParams();

    useEffect(() => {
        dispatch(fetchManageTeamList({
            sort: sortBy,
            sortOrder,
            name: searchText,
            status,
            perPage,
            page
        }));
    }, [page, perPage, status, searchText, sortOrder, sortBy]);

    return (
        <>
            {teamId ? (
                <Outlet/>
            ) : (
                <AppContainer>
                    <AppBox py="md" flexDirection="column" gap="md">
                        <TeamList/>
                        {teamList.pageCount > 1 &&
                            <AppPaginator perPage={teamList?.perPage}
                                          pageCount={teamList?.pageCount}
                                          currentPage={teamList?.page}
                                          pageChange={pageChange}
                                          perPageLimitChange={pageLimitChange}
                            />
                        }
                    </AppBox>
                </AppContainer>
            )}
        </>
    );
}
